import React from 'react';
import {observer} from "mobx-react";
import {selectedCompanyStore} from "../store/SelectedCompany";
import Loader from "./Loader";
import {ActiveSubscriptionStatus} from "../model/billing/ActiveSubscriptionStatusDto";
import {Alert, AlertTitle, Grid, Typography} from "@mui/material";
import {Link} from "react-router-dom";
import {routes} from "../main/Routes";
import {CustomerBillingPlan} from "../views/billing/CustomerBillingPlan";

interface IProps {
    onlyNotify: boolean
}

interface IState {
}

@observer
export default class WithSubscription extends React.Component<IProps, IState> {

    render() {
        const {children, onlyNotify} = this.props;
        if (!selectedCompanyStore.isLoadingSubscription || onlyNotify) {
            const status = selectedCompanyStore.subscriptionStatus;
            //We don't want to show warning to accountant
            if (status === ActiveSubscriptionStatus.UNPAID && !onlyNotify) {
                return <Grid container>
                    <Grid item xs={12}>
                        <Alert severity={"warning"}>
                            <Typography variant={"subtitle2"}>Company has unpaid subscription. Access will be blocked soon.</Typography>
                            <Typography variant={"body2"}>Please go to the <Link to={routes.billing}>subscription</Link> page to make a payment</Typography>
                        </Alert>
                    </Grid>
                    <Grid item xs={12}>
                        {children}
                    </Grid>
                </Grid>
            }

            //Accountant should know that client is blocked atm
            if (status === ActiveSubscriptionStatus.BLOCKED) {
                return <Grid container>
                    <Grid item xs={12}>
                        <Alert severity={"error"}>
                            <AlertTitle><Typography variant={"subtitle2"}>Company has unpaid subscription. Access to the company is blocked.</Typography></AlertTitle>
                            <Typography variant={"body2"}>Please make sure the card information is up to date and retry payment.</Typography>
                        </Alert>
                    </Grid>
                    <Grid item xs={12}>
                        {onlyNotify && children}
                        {!onlyNotify && <CustomerBillingPlan/>}
                    </Grid>
                </Grid>
            }

            if (onlyNotify || status === ActiveSubscriptionStatus.ACTIVE || status === ActiveSubscriptionStatus.DISABLED) {
                return <>
                    {children}
                </>;
            }
        } else {
            return <Loader loading={true}/>
        }
    }


}